<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Staff Attendance - Daily Report</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">

        </div>
      </div>
    </div>
    <div>
      <daily-report></daily-report>
    </div>
  </div>
</template>

<script>
import dailyReport from '@/components/StaffAttendance/dailyreport'

export default {
  name: '',
  components: { dailyReport },
}
</script>

<style>

</style>
